<h2 mat-dialog-title>Copy collection</h2>
<mat-dialog-content>
  <p>Choose a collection. The content will be copied to the current workspace.</p>
  <mat-form-field appearance="outline" class="full-width">
    @if (collectionIsLoading$ | async) {
      <mat-progress-bar class="mat-form-loader" mode="indeterminate"></mat-progress-bar>
    }
    <mat-label>Select collection</mat-label>

    <mat-select [formControl]="selectedCollectionId" placeholder="Choose an element">
      @if (availableCollections$ | async; as collections) {
        @for (collection of collections; track collection.collection_id) {
          <mat-option [value]="collection.collection_id"> {{ collection.name }} </mat-option>
        }
        @if (collections.length === 0) {
          <mat-option disabled>No elements available.</mat-option>
        }
      } @else {
        <mat-option disabled>No elements available.</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (collectionDocsIsLoading$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (collectionFiles$ | async; as collectionFiles) {
    <table mat-table [dataSource]="collectionFiles" class="full-width-table">
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let element" class="title-cell">
          {{ element | catalogueValue: 'title' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef>Year</th>
        <td mat-cell *matCellDef="let element">
          {{ element | catalogueValue: 'year' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="processing_stage">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <span class="status-pill" [ngClass]="element.processing_stage | statusColor">
            {{ element.processing_stage | processingStage }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="file_id">
        <th mat-header-cell *matHeaderCellDef>File ID</th>
        <td mat-cell *matCellDef="let element">{{ element.file_id }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">No file metadata to display.</td>
      </tr>
    </table>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [disabled]="isPending" (click)="onNoClick()">Cancel</button>
  <app-loader-button mat-button [loading]="isPending" (click)="onConfirm()">Confirm</app-loader-button>
</mat-dialog-actions>
